import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M27.643 2.357 2.421 27.579C1.222 25.826.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263a8 8 0 0 1 1.953 1.094",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M4.353 29.647 29.585 4.415c1.22 1.766 1.582 3.494 1.582 3.494.663 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23a8 8 0 0 1-1.99-1.123",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M2.794 3.91q.217-.279.466-.552l.27-.005.145-.419q.236-.226.497-.439l.298.858 1.432.029-1.141.865.414 1.371L4 4.8l-1.176.818.415-1.37zm5.873 4.557-1.176.818.415-1.371-1.141-.865 1.432-.03.47-1.352.47 1.352 1.432.03-1.141.865.414 1.37zM4 12.133l-1.176.818.415-1.37-1.141-.866 1.432-.029L4 9.333l.47 1.353 1.432.03-1.141.865.414 1.37zm9.333 0-1.175.818.414-1.37-1.14-.866 1.431-.029.47-1.353.47 1.353 1.432.03-1.14.865.414 1.37zm0-7.333-1.175.818.414-1.37-1.14-.866 1.431-.03.47-1.352.47 1.353 1.432.029-1.14.865.414 1.371z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagSlb = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSlb_default = SvgFlagSlb;

export { FlagSlb_default as default };
